import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index.vue'
import list from '../views/list.vue'
import detail from '../views/detail.vue'
import biddinglist from '../views/biddinglist.vue'
import layout from '@/layout/BasicLayout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      component: layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          meta: {title: '首页', ishome: true, keepAlive: true},
          component: index
        },
        {
          path: '/list',
          name: 'list',
          meta: {title: '列表'},
          component: list
        },
        {
          path: '/detail',
          name: 'detail',
          meta: {title: '详情'},
          component: detail
        },
        {
          path: '/biddinglist',
          name: 'biddinglist',
          meta: {title: '竞价大厅'},
          component: biddinglist
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js